import { useEffect, useState } from "react";

/* Thin progress stripe that fills as the reader scrolls through an article. Sticks directly under the sticky site header. */
export const ReadingProgressBar = () => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const onScroll = () => {
      const scrollTop = window.scrollY;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      const pct = docHeight > 0 ? (scrollTop / docHeight) * 100 : 0;
      setProgress(Math.min(100, Math.max(0, pct)));
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      className="sticky top-16 z-40 h-[3px] w-full bg-[hsl(var(--primary))]/10"
      data-testid="article-reading-progress-bar"
    >
      <div
        className="h-full bg-[hsl(var(--accent))] transition-[width] duration-150 ease-out"
        style={{ width: `${progress}%` }}
        data-testid="article-reading-progress-fill"
      />
    </div>
  );
};
